<template>
  <div v-loading="loading">
    <el-input
      v-model="config.title"
      clearable=""
      style="margin-bottom:10px;"
      placeholder="请输入政策资讯标题">
      <el-button
        slot="append"
        icon="el-icon-search"
        @click="fetch"></el-button>
    </el-input>
    <el-table
      :data="list"
      height="520px"
      border=""
      @row-click="selectitem">
      <el-table-column
        prop="title"
        label="政策资讯标题"
        min-width="240">
      </el-table-column>
      <el-table-column
        prop="topicName"
        label="分组"
        min-width="100">
      </el-table-column>
    </el-table>
    <pagination-new
      v-model="config"
      :total="total"
      :fetch="fetchList" />
  </div>
</template>
<script>
import Common from '@/service/common'
export default {
  name: 'NewsInfo',
  props: {
    linkType: { type: Number, default: 200 }
  },
  data() {
    return { loading: false, list: [], total: 0, config: { pageNum: 1, pageSize: 10, title: '' }}
  },
  mounted() {
    this.fetchList()
  },
  methods: {
    fetch() {
      this.config.pageNum = 1
      this.fetchList()
    },
    selectitem(item) {
      this.$emit('select', { linkType: this.linkType, link: item.id, title: item.title })
    },
    fetchList() {
      this.loading = true
      Common.getinfos({ ...this.config })
        .then(res => {
          const { result, message, records, total } = res.data
          this.loading = false
          if ([0].includes(result)) {
            this.list = records
            this.total = total
          } else {
            this.$message.error(message)
          }
        })
        .catch(err => {
          this.$message.error(err.message)
        })
    }
  }
}
</script>
